if (!customElements.get('adev-cart-drawer-recommended')) {
    customElements.define('adev-cart-drawer-recommended', class adevCartDrawerRecommended extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const cart = this.closest('adev-cart-drawer');
            if (!cart) return;

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.handleInView();
                        this.observer.disconnect();
                    }
                });
            });

            this.observer.observe(cart);
        }

        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }

        handleInView() {
            const url = this.dataset.url;
            if (!url) return;

            const innerEl = this.querySelector('[data-adev-cart-drawer-recommended="inner"]');
            if (!innerEl) return;

            fetch(url)
                .then(response => response.text())
                .then(html => {
                    const domParser = new DOMParser();
                    const doc = domParser.parseFromString(html, 'text/html');
                    const recommendedProductsEl = doc.querySelector('adev-cart-drawer-recommended-carousel');
                    
                    innerEl.innerHTML = ''; // Clear any existing content

                    if (recommendedProductsEl) {
                        innerEl.appendChild(recommendedProductsEl);
                    }

                    this.classList.add('is--loaded');
                })
                .catch(error => {
                    console.error('Error fetching recommended products:', error);
                });
        }

    });
}

if (!customElements.get('adev-cart-drawer-recommended-carousel')) {
    customElements.define('adev-cart-drawer-recommended-carousel', class adevCartDrawerRecommendedCarousel extends HTMLElement {
        constructor() {
            super();

            this.prevEl = this.querySelector('[data-adev-cart-drawer-recommended-carousel="prev"]');
            this.nextEl = this.querySelector('[data-adev-cart-drawer-recommended-carousel="next"]');
            this.carouselInnerEl = this.querySelector('[data-adev-cart-drawer-recommended-carousel="inner"]');
        }

        scrollPrev() {
            const currentActiveItem = this.carouselInnerEl.querySelector('[data-adev-cart-drawer-recommended-carousel="item"].is--active');
            const prevItem = currentActiveItem ? currentActiveItem.previousElementSibling : null;

            if (prevItem) {
                currentActiveItem.classList.remove('is--active');
                prevItem.classList.add('is--active');

                const itemWidth = prevItem.offsetWidth;
                this.carouselInnerEl.scrollBy({ left: -itemWidth, behavior: 'smooth' });
                this.updateNavigationButtons();
            }
        }

        scrollNext() {
            const currentActiveItem = this.carouselInnerEl.querySelector('[data-adev-cart-drawer-recommended-carousel="item"].is--active');
            const nextItem = currentActiveItem ? currentActiveItem.nextElementSibling : null;

            if (nextItem) {
                currentActiveItem.classList.remove('is--active');
                nextItem.classList.add('is--active');
                const itemWidth = nextItem.offsetWidth;
                this.carouselInnerEl.scrollBy({ left: itemWidth, behavior: 'smooth' });
                this.updateNavigationButtons();
            }
        }

        updateNavigationButtons() {
            const currentActiveItem = this.carouselInnerEl.querySelector('[data-adev-cart-drawer-recommended-carousel="item"].is--active');
            if (!currentActiveItem) return;

            this.prevEl.disabled = !currentActiveItem.previousElementSibling;
            this.nextEl.disabled = !currentActiveItem.nextElementSibling;
        }

        connectedCallback() {
            this.prevEl.addEventListener('click', this.scrollPrev.bind(this));
            this.nextEl.addEventListener('click', this.scrollNext.bind(this));
            this.updateNavigationButtons();
        }

        disconnectedCallback() {
            this.prevEl.removeEventListener('click', this.scrollPrev.bind(this));
            this.nextEl.removeEventListener('click', this.scrollNext.bind(this));
        }

    });
}